import * as Reducers from './kron.reducers';

export const KronReducers = {
  Reducers,
};
